import React, { useState } from 'react';
import axios from 'axios';
import './TopUp.css'; // Make sure to create this file for styling

const ManageTopUp = () => {
  const [email, setEmail] = useState('');
  const [userData, setUserData] = useState(null);
  const [updatedData, setUpdatedData] = useState({});

  const handleInputChange = (e) => {
    setEmail(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // Fetching user data from the backend
      const response = await axios.post('https://sharedvision-partners.online/v1/API/get_user.php', {
        email,
      });
      if (response.data.success) {
        setUserData(response.data.user); // Assuming the response has the user data in 'user' field
      } else {
        alert('User not found');
      }
    } catch (error) {
      console.error('Error fetching user data:', error);
    }
  };

  const handleUpdate = (key, value) => {
    setUpdatedData((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const handleSave = async () => {
    try {
      const response = await axios.post('https://sharedvision-partners.online/v1/API/update_user.php', {
        email,
        ...updatedData,
      });

      if (response.data.success) {
        alert('User updated successfully!');
        setUserData((prev) => ({
          ...prev,
          ...updatedData,
        }));
        setUpdatedData({});
      } else {
        alert('Failed to update user');
      }
    } catch (error) {
      console.error('Error updating user:', error);
    }
  };

  return (
    <div className="form-container">
      <h2>User Information Update</h2>
      <form onSubmit={handleSubmit} className="user-form">
        <input
          type="email"
          value={email}
          onChange={handleInputChange}
          placeholder="Enter user email"
          required
          className="form-input"
        />
        <button type="submit" className="submit-button">
          Fetch User Details
        </button>
      </form>

      {userData && (
        <div className="user-details">
          <h3>User Details:</h3>
          <div className="user-item">
            <strong>Name: </strong>
            <input
              type="text"
              value={updatedData.name || userData.name}
              onChange={(e) => handleUpdate('name', e.target.value)}
              className="form-input"
            />
          </div>
          <div className="user-item">
            <strong>Email: </strong>
            <input
              type="email"
              value={updatedData.email || userData.email}
              onChange={(e) => handleUpdate('email', e.target.value)}
              className="form-input"
            />
          </div>
          <div className="user-item">
            <strong>Phone: </strong>
            <input
              type="text"
              value={updatedData.phone || userData.phone}
              onChange={(e) => handleUpdate('phone', e.target.value)}
              className="form-input"
            />
          </div>
          {/* Add more fields as necessary */}

          <button onClick={handleSave} className="submit-button">
            Save Changes
          </button>
        </div>
      )}
    </div>
  );
};




export default ManageTopUp;
